<template>
  <div class="required-description-content">
    <h6><span class="required-description-asterisk">*</span> - required field</h6>
  </div>
</template>

<script>
export default {}
</script>
